export const AT_RENAME = 'CARD_NAME_RENAME';
